import React from 'react'
import PropTypes from 'prop-types'

const QuizItem = ({ answerText }) =>
  answerText ? (
    <div className='quiz-results__text-choice fr-view'>
      <span dangerouslySetInnerHTML={{ __html: answerText }} />
    </div>
  ) : (
    <span className='quiz-results__choice--absent'>{I18n.t('react.cabinet.quiz.no_answer')}</span>
  )

QuizItem.propTypes = {
  answerText: PropTypes.string,
}
QuizItem.displayName = 'QuizItem'

export default React.memo(QuizItem)
